export default "__VITE_PUBLIC_ASSET__e57b122e__"